<template>
	<div>
		<v-container fluid grid-list-xl pt-0 px-0>
			<v-card elevation="0">
				<v-container fluid grid-list-xl class="toolbar-container">
					<v-layout row wrap :class="$bp.smallScreen ? 'mx-0' : null">
						<v-toolbar color="transparent" flat elevation="0">
							<v-toolbar-title class="ml-0" style="font-size: 24px"
								>{{ $t($route.meta.title) }}<bc-breadcrumbs :items="breadcrumb_items"></bc-breadcrumbs
							></v-toolbar-title>
							<v-spacer></v-spacer>
							<!-- <bc-btn-refresh
                                @invoke-method="dbGetModules(true)"
                            ></bc-btn-refresh> -->
						</v-toolbar>
					</v-layout>
				</v-container>
				<v-card :elevation="$bp.smAndUp ? '5' : '0'" max-width="500" class="mx-auto" :class="$bp.smAndUp ? 'mt-3' : 'mt-2'">
					<v-card-text px-2>
						<v-layout xs12 row wrap>
							<!-- FRONT CAM  -->
							<v-flex xs4 my-auto px-1>{{ $t("lang.has_front_camera") }}</v-flex>
							<v-flex xs3 my-auto text-center pa-0 style="width: 100px">
								<v-progress-circular v-if="check_front" class="mx-auto" indeterminate color="rgb(77, 133, 255)"></v-progress-circular>
								<bc-tooltip class="ma-auto" v-else-if="has_front_cam.icon">
									<template slot="activator">
										<v-icon :color="has_front_cam.class" large>{{ has_front_cam.icon }}</v-icon>
									</template>
									{{ has_front_cam.tooltip }}
								</bc-tooltip>
								<span v-else class="fw-bold">{{ $t("lang.unknown") }}</span>
							</v-flex>
							<v-flex xs5 px-1 style="height: 65px">
								<v-btn :disabled="check_front" class="ma-0" @mouseup.left="clickButton(has_front_cam)" :color="has_front_cam.button_color">
									{{ has_front_cam.button_text }}
								</v-btn>
							</v-flex>
							<!-- REAR CAM  -->
							<v-flex xs4 my-auto px-1> {{ $t("lang.has_rear_camera") }} </v-flex>
							<v-flex xs3 ma-auto text-center pa-0 style="width: 100px">
								<v-progress-circular v-if="check_rear" class="mx-auto" indeterminate color="rgb(77, 133, 255)"></v-progress-circular>
								<bc-tooltip v-else-if="has_rear_cam.icon">
									<template slot="activator">
										<v-icon :color="has_rear_cam.class" large>{{ has_rear_cam.icon }}</v-icon>
									</template>
									{{ has_rear_cam.tooltip }}
								</bc-tooltip>
								<span v-else class="fw-bold">{{ $t("lang.unknown") }}</span>
							</v-flex>
							<v-flex xs5 px-1 style="height: 65px">
								<v-btn :disabled="check_rear" class="ma-0" @mouseup.left="clickButton(has_rear_cam)" :color="has_rear_cam.button_color">
									{{ has_rear_cam.button_text }}
								</v-btn>
							</v-flex>
							<!-- CAM PREF -->
							<v-flex xs4 my-auto px-1> {{ $t("lang.default_camera") }} </v-flex>
							<v-flex xs3 my-auto text-center pa-0 style="width: 100px">
								<bc-autocomplete
									v-if="camera_options.length > 0"
									:value="default_camera"
									single-line
									:items="camera_options"
									item-text="text"
									item-value="value"
									class="pt-0"
									@change="setCookie('bc-default-camera', $event)"
								></bc-autocomplete>
								<span v-else class="fw-bold">{{ has_front_cam.value == "0" && has_rear_cam.value == "0" ? "NONE" : "AUTO" }}</span>
							</v-flex>
							<v-flex xs5 px-1 style="height: 65px"> </v-flex>
							<!-- LOGIN PREF  -->
							<v-flex xs4 my-auto px-1> {{ $t("lang.primary_login") }} </v-flex>
							<v-flex xs3 my-auto text-center pa-0 style="width: 100px">
								<bc-autocomplete
									value="credentials"
									single-line
									:items="login_options"
									item-text="text"
									item-value="value"
									class="pt-0"
								></bc-autocomplete>
							</v-flex>
							<v-flex xs5 px-1 style="height: 65px"> </v-flex>
						</v-layout>
					</v-card-text>
				</v-card>
				<v-flex v-if="total_prefs > 0" style="max-width: 500px" class="mx-auto mt-2">
					<v-btn color="error" @mouseup.left="clearPref()">{{ $t("lang.clear_preferences") }}</v-btn>
					<v-spacer></v-spacer>
				</v-flex>
			</v-card>
		</v-container>
		<bc-camera v-if="check_front" :start="'front'" :detect="true" @done="check_front = false"></bc-camera>
		<bc-camera v-if="check_rear" :start="'rear'" :detect="true" @done="check_rear = false"></bc-camera>
	</div>
</template>

<script>
import { mapGetters, mapState } from "vuex";
import { store } from "Store/store";
import BcCamera from "Components/Camera/BcCamera";

export default {
	data() {
		return {
			breadcrumb_items: [
				{
					text: "Dashboard",
					link: true,
					exact: true,
					disabled: false,
					to: {
						name: "dashboard",
					},
				},
				{
					text: "Configuration",
					link: true,
					exact: true,
					disabled: false,
					to: {
						name: "configuration",
						params: { tab: 5 },
					},
				},
				{
					text: "Configure Environment",
					disabled: true,
					href: "",
				},
			],
			login_options: [
				{ value: "rfid", text: "RFID" },
				{ value: "qrcode", text: "QR Code" },
				{ value: "credentials", text: this.$t("lang.credentials") },
			],
			check_front: !$cookies.isKey("bc-front-cam"),
			check_rear: !$cookies.isKey("bc-rear-cam"),
		};
	},
	beforeRouteEnter(to, from, next) {
		// store.dispatch(
		//     "fetchModules",
		//     {
		//         url: 'modules',
		//         method: 'get',
		//         stateProperty: 'modules',
		//         commit: true
		//     }
		// ).then((data) => {
		//     if (typeof(data) !== 'undefined' && data.modules)
		//     {
		//         next(vm => {
		//             vm.finishLoader();
		//         })
		//     } else {
		//         next({ name: 'dashboard', replace: true })
		//     }
		// })
		next((vm) => {
			vm.finishLoader();
		});
	},
	beforeRouteUpdate(to, from, next) {
		// this.$store.dispatch(
		//     "fetchModules",
		//     {
		//         url: 'modules',
		//         method: 'get',
		//         stateProperty: 'modules',
		//         commit: true
		//     }
		// ).then((data) => {
		//     if (typeof(data) !== 'undefined' && data.modules)
		//     {
		//         this.finishLoader();
		//         next();
		//     } else {
		//         next({ name: 'dashboard', replace: true })
		//     }
		// })

		this.finishLoader();
		next();
	},
	watch: {
		camera_options: function (newVal) {
			if (newVal.find((e) => e.value == "rear")) {
				$cookies.set("bc-default-camera", "rear");
			} else if (newVal.find((e) => e.value == "front")) {
				$cookies.set("bc-default-camera", "front");
			} else {
				$cookies.remove("bc-default-camera");
			}
		},
	},
	computed: {
		has_front_cam() {
			let c = {};
			if ($cookies.isKey("bc-front-cam")) {
				c.value = $cookies.get("bc-front-cam");
				if (c.value == "1") {
					c.class = "success";
					c.icon = "check";
					c.tooltip = "Front camera access";
					c.button_text = "Remove Access";
					c.button_color = "error";
					c.button_action = "setCookie";
					c.button_params = ["bc-front-cam", "0"];
				} else {
					c.class = "error";
					c.icon = "close";
					c.tooltip = "No front camera";
					c.button_text = "Detect/Enable";
					c.button_color = "primary";
					c.button_action = "toggleCamera";
					c.button_params = ["check_front", true];
				}
			} else {
				c.value = "-1";
				c.class = "black";
				c.icon = null;
				c.tooltip = "Not checked for camera";
				c.button_text = "Detect";
				c.button_color = "primary";
				c.button_action = "toggleCamera";
				c.button_params = ["check_front", true];
			}
			return c;
		},
		has_rear_cam() {
			let c = {};
			if ($cookies.isKey("bc-rear-cam")) {
				c.value = $cookies.get("bc-rear-cam");
				if (c.value == "1") {
					c.class = "success";
					c.icon = "check";
					c.tooltip = "Rear camera access";
					c.button_text = "Remove Access";
					c.button_color = "error";
					c.button_action = "setCookie";
					c.button_params = ["bc-rear-cam", "0"];
				} else {
					c.class = "error";
					c.icon = "close";
					c.tooltip = "No rear camera";
					c.button_text = "Detect/Enable";
					c.button_color = "primary";
					c.button_action = "toggleCamera";
					c.button_params = ["check_rear", true];
				}
			} else {
				c.value = "-1";
				c.class = "black";
				c.icon = null;
				c.tooltip = "Not checked for camera";
				c.button_text = "Detect";
				c.button_color = "primary";
				c.button_action = "toggleCamera";
				c.button_params = ["check_rear", true];
			}
			return c;
		},
		default_camera() {
			return $cookies.get("bc-default-camera");
		},
		primary_login() {
			if ($cookies.isKey("bc-primary_login")) {
				return $cookies.get("bc-primary_login");
			} else {
				return "username";
			}
		},
		total_prefs() {
			let count = 0;
			$cookies.keys().forEach((cookie) => {
				if (cookie.startsWith("bc-")) count++;
			});
			return count;
		},
		camera_options() {
			let options = [];
			if ($cookies.get("bc-rear-cam") == "1") options.push({ value: "rear", text: "Rear" });
			if ($cookies.get("bc-front-cam") == "1") options.push({ value: "front", text: "Front" });
			return options;
		},
	},
	methods: {
		clickButton(btn) {
			this[btn.button_action].apply(this[btn.button_action], btn.button_params);
		},
		clearPref() {
			$cookies.keys().forEach((cookie) => {
				$cookies.remove(cookie);
			});
			this.createAlert("error", "pref_cleared");
		},
		setCookie(cookie, value = null) {
			if (cookie) {
				if (value) {
					$cookies.set(cookie, value);
				} else {
					$cookies.remove(cookie);
				}
			}
		},
		toggleCamera(camera, value) {
			this[camera] = value;
		},
	},
	components: {
		BcCamera,
	},
};
</script>
